import { render, staticRenderFns } from "./ResultIndex.vue?vue&type=template&id=14e3b7e4"
import script from "./ResultIndex.vue?vue&type=script&lang=js"
export * from "./ResultIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports